import classNames from "classnames";
import { NavItem } from "reactstrap";
import { menuUrl } from "domain/menuOptions";
import { Link } from "react-router-dom";

type MenuItemProps = {
  selected: boolean;
  item: string;
  disabled?: boolean;
};

export const MenuItem = ({ selected, item, disabled }: MenuItemProps) => {
  return (
    <Link to={menuUrl(item)}>
      <NavItem
        className={classNames("menu-item-container", {
          active: selected,
        })}
        disabled={disabled}
      >
        <div className="menu-item">
          <div aria-current={selected} className="lbl">
            {item}
          </div>
          <div className="arrow right"></div>
        </div>
      </NavItem>
    </Link>
  );
};
